import React from 'react';
import styled from 'styled-components';
import { CLICKABLE_ELEMENT_CSS_MIXIN } from '../../../style/styleConstants';
import { EnrichedProductDiscoveryConversationMessage } from '../../../lib/productDiscovery/conversationMessages';
import { colors } from '../../../tokens/colors/colors';
import { logUserEventUtil } from '../../../lib/events/userEvents';
import { useApolloClient } from '@apollo/react-hooks';
import { JokoAiBetaTitle } from '../common/JokoAiBetaTitle';
import { font } from '../../../style/text';
import { getLocalizedTexts } from '../../../Locales';
import { TabType } from '../ProductDiscoveryPage';

const sidebar = '/assets/images/icons/sidebar.svg';
const editIcon = '/assets/images/icons/edit.svg';

export function MobileHeader({
    resetConversation,
    shouldShowConversationHistory,
    setShouldShowConversationHistory,
    displayedTab,
    inputTextRef,
}: {
    resetConversation: ({
        conversationToReopen,
    }: {
        conversationToReopen?: {
            conversationId: string;
            messages: EnrichedProductDiscoveryConversationMessage[];
        };
    }) => void;
    shouldShowConversationHistory: boolean;
    setShouldShowConversationHistory: (value: boolean) => void;
    displayedTab: TabType;
    inputTextRef: React.RefObject<HTMLTextAreaElement | null>;
}) {
    const apolloClient = useApolloClient();
    const texts = getLocalizedTexts().productDiscovery.favoritesTab;
    return (
        <HeaderContainer>
            <HeaderImage
                src={sidebar}
                draggable={false}
                onClick={() => setShouldShowConversationHistory(!shouldShowConversationHistory)}
            />
            {displayedTab === TabType.favorites ? (
                <FavoriteProductsTitle>{texts.title}</FavoriteProductsTitle>
            ) : (
                <JokoAiBetaTitle />
            )}
            <HeaderImage
                src={editIcon}
                draggable={false}
                onClick={() => {
                    resetConversation({});
                    inputTextRef.current?.focus();
                    logUserEventUtil(apolloClient, {
                        type: 'clickedNewConversationButtonOnJokoAi',
                    });
                }}
            />
        </HeaderContainer>
    );
}

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 4px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${colors.border.subtle};);
`;

const HeaderImage = styled.img`
    width: 24px;
    height: 24px;
    padding: 12px;
    ${CLICKABLE_ELEMENT_CSS_MIXIN}
`;

const FavoriteProductsTitle = styled.div`
    font-family: ${font.ambitBold};
    font-size: 18px;
    color: ${colors.content.default};
    text-align: center;
`;
